import { Box, Button } from "@mui/material";
import React from "react";

import { TimeRange } from "../../../../../helpers/dateRangeHelpers";

interface TimeRangeSelectorProps {
  ranges: TimeRange[];
  selectedTimeRange: TimeRange;
  onTimeRangeChange: (range: TimeRange) => void;
}

/**
 * Reusable time range selector component
 * Displays buttons for different time ranges (1D, 1W, 1M, 6M, 1Y)
 */
const TimeRangeSelector: React.FC<TimeRangeSelectorProps> = ({
  ranges,
  selectedTimeRange,
  onTimeRangeChange,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      mb={1}
      sx={{
        padding: "4px",
        width: "100%",
        height: "40px",
        background: "#F6F6F6",
        borderRadius: "14px",
        alignItems: "center",
      }}
    >
      {ranges.map((range) => (
        <Button
          key={range}
          variant="text"
          onClick={() => onTimeRangeChange(range)}
          sx={{
            p: "6px 8px",
            height: 32,
            minHeight: 32,
            bgcolor: selectedTimeRange === range ? "#FFFFFF" : "transparent",
            border: selectedTimeRange === range ? "1px solid #E8E8E9" : "none",
            borderRadius: "10px",
            flex: 1,
            textTransform: "none",
            fontWeight: 500,
            fontSize: "12px",
            color: "#000000",
            "&:hover": {
              bgcolor:
                selectedTimeRange === range ? "#FFFFFF" : "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          {range}
        </Button>
      ))}
    </Box>
  );
};

export default TimeRangeSelector;
